// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import MainMenu from './MainMenu';
import SettingsPanel from './SettingsPanel';
// Import hook to get context state and functions
import { useSettings } from '../contexts/SettingsContext';
import * as MdIcons from 'react-icons/md'; // For settings icon
import './Layout.css'; // Import layout styles

function Layout() {
  // Get necessary state and functions from context
  const { settingsState, toggleSettingsPanel, sampleAudioRef, clearSampleAudio } = useSettings();
  const isPanelVisible = settingsState.isSettingsPanelVisible;

  // Event handlers for the shared sample audio element
  const handleSampleAudioEnded = () => {
      // console.log("Sample audio ended.");
      clearSampleAudio(); // Clear URL and related state in context
  };

  const handleSampleAudioError = (e) => {
      console.error("Sample audio element error:", e);
      clearSampleAudio(); // Clear URL and related state in context on error
  };


  return (
    <div className="app-layout">
      <MainMenu /> {/* Render the sidebar menu */}

      <div className="main-content"> {/* Container for page content + overlays */}

        {/* Button to toggle settings panel */}
        <button
            onClick={toggleSettingsPanel}
            className="settings-toggle-button"
            aria-label="Toggle Settings"
            title="Toggle Settings"
        >
            <MdIcons.MdSettings size="1.8em"/>
        </button>

        {/* Conditionally render the Settings Panel overlay */}
        {/* Pass className for specific overlay styles from Layout.css */}
        {isPanelVisible && <SettingsPanel className="settings-panel-overlay" />}

        {/* Hidden audio element dedicated to playing samples triggered from context */}
        {/* It uses the ref and URL managed by SettingsContext */}
        <audio
            ref={sampleAudioRef} // Assign ref from context
            onEnded={handleSampleAudioEnded} // Call context cleanup on end
            onError={handleSampleAudioError} // Call context cleanup on error
            hidden // Keep it non-visible
            // src is set dynamically via useEffect in SettingsContext
        />

        {/* Outlet renders the matched child route component (e.g., HomePage, PictureDescriptionUI) */}
        <div className="page-content">
             <Outlet />
        </div>

      </div> {/* End main-content */}
    </div> // End app-layout
  );
}

export default Layout;